import React from "react"
import { EntregadoresContextProvider } from "./context/EntregadoresContextProvider"
import { ListarEntregadores } from "./ListarEntregadores"

export function Index() {
    return (
        <EntregadoresContextProvider>
            <ListarEntregadores />
        </EntregadoresContextProvider>
    )
}
